/**
 * create a redux selector mapped to the featureKey.
 * @returns a redux selector, which returns an array of name valuee objects.
 */

export const createFeatureFlagSelector = (featureKey) => (state) => {
    if (state && typeof state.featureflags == "object") {
        const flags = Object.keys(state.featureflags);
        return flags
            .filter((flag) => flag.startsWith(featureKey))
            .map((key) => {
                return {
                    //convert key to path e.g. "foo.bar" => "foo/bar"
                    path: key
                        .replace(featureKey, "")
                        .split(".")
                        .slice(1)
                        .join("/"),
                    value: state.featureflags[key],
                };
            });
    }
    return [];
};

export const featureFlagFind = (section, featureList) => {
    const obj = featureList.find(({ path }) => section.startsWith(path));
    return (obj && obj.value) || {};
};
